// Универсальная «обёртка» ответов бэка
export type ApiEnvelope<T> = {
  success?: boolean;
  Success?: boolean;
  data?: T;
  Data?: T;
  errorMessage?: string;
  ErrorMessage?: string;
};

// Удобный тип для ID
export type Id = string | number;

// Хелперы для обработки обёрток
export const opOk = <T>(x: ApiEnvelope<T> | null | undefined): boolean =>
  !!x && (x.success === true || x.Success === true);

export const opData = <T>(x: ApiEnvelope<T> | null | undefined): T | undefined =>
  (x?.data as T | undefined) ?? (x?.Data as T | undefined);

export const opError = (x: ApiEnvelope<unknown> | null | undefined): string =>
  x?.errorMessage ?? x?.ErrorMessage ?? "Unknown error";
